import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, TrendingUp, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-147">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand/20 blur-[120px] rounded-full pointer-events-none" data-id="element-148" />

      <div className="max-w-4xl mx-auto text-center relative z-10 mt-[-50px] mb-[-50px]" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full mb-8" data-id="element-150">
          <span className="text-xl" data-id="element-151">💅</span>
          <span className="text-sm font-bold tracking-widest text-gray-300" data-id="element-152">
            ULTRAPACK DIGITAL™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-black tracking-tight mb-6 leading-[1.1]" data-id="element-153">
          Tu negocio de uñas
          <br data-id="element-154" />
          <span className="text-brand" data-id="element-155">Completo. Desde hoy.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-lg text-gray-500 mb-10 max-w-2xl mx-auto" data-id="element-156">
          Sin improvisar. Sin adivinar. Sin perder más tiempo trabajando mucho y
          ganando poco.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-157">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }].map((badge, i) => <div key={i} className="flex items-center space-x-2 bg-dark-card border border-dark-border px-3 py-1.5 rounded-md text-sm text-gray-300" data-id="element-158">
              <badge.icon className="w-4 h-4 text-brand" data-id="element-159" />
              <span data-id="element-160">{badge.text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-161">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand hover:bg-brand-dark text-white text-xl font-bold py-5 px-10 rounded-xl shadow-[0_0_40px_rgba(244,63,122,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(244,63,122,0.6)] flex items-center justify-center space-x-3" data-id="element-162">
            <span className="text-[24px] pt-[0px] pb-[0px]" data-id="element-163">
              QUIERO MI ULTRAPACK AHORA
            </span>
          </button>

          <div className="flex items-center space-x-6 mt-6 text-gray-500 text-[20px] font-[800]" data-id="element-164">
            <div className="flex items-center space-x-1" data-id="element-165">
              <Shield className="w-4 h-4" data-id="element-166" />
              <span data-id="element-167">Garantía 7 días</span>
            </div>
            <div className="flex items-center space-x-1 text-[8px]" data-id="element-168">
              <Lock className="w-4 h-4" data-id="element-169" />
              <span data-id="element-170">Pago seguro</span>
            </div>
            <div className="flex items-center space-x-1 text-[8px]" data-id="element-171">
              <CreditCard className="w-4 h-4" data-id="element-172" />
              <span data-id="element-173">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}